import { Link } from 'react-router-dom'
import { Card, CardContent } from '@/components/ui/card'
import type { CommunitySummary } from '@/api/types'

export const CommunityCard = ({ community }: { community: CommunitySummary }) => {
  const accent = community.accentColor ?? '#6366F1'
  return (
    <Link to={`/c/${community.slug}`} className="block transition-transform hover:-translate-y-0.5">
      <Card className="overflow-hidden">
        <div
          className="h-20 w-full"
          style={{
            background: `linear-gradient(135deg, ${accent}, ${accent}80)`,
          }}
        />
        <CardContent className="space-y-2 p-4">
          <div className="flex items-baseline justify-between gap-2">
            <h3 className="text-base font-semibold tracking-tight">{community.name}</h3>
            <span className="text-xs text-muted-foreground">/c/{community.slug}</span>
          </div>
          {community.description && (
            <p className="line-clamp-2 text-sm text-muted-foreground">{community.description}</p>
          )}
          <div className="flex gap-3 pt-1 text-xs text-muted-foreground">
            <span>
              {community.memberCount} {community.memberCount === 1 ? 'member' : 'members'}
            </span>
            <span>
              {community.projectCount} {community.projectCount === 1 ? 'project' : 'projects'}
            </span>
          </div>
        </CardContent>
      </Card>
    </Link>
  )
}
